(function () {
  var EN_MODE = /^en\b/i.test(document.documentElement.lang || '');
  var INVARIANT = ['g', 'kg', 'dag', 'ml', 'l', 'szt'];
  var FORMS = {
    'łyżka':      ['łyżka', 'łyżki', 'łyżek', 'łyżki'],
    'łyżeczka':   ['łyżeczka', 'łyżeczki', 'łyżeczek', 'łyżeczki'],
    'ząbek':      ['ząbek', 'ząbki', 'ząbków', 'ząbka'],
    'garść':      ['garść', 'garście', 'garści', 'garści'],
    'kromka':     ['kromka', 'kromki', 'kromek', 'kromki'],
    'szczypta':   ['szczypta', 'szczypty', 'szczypt', 'szczypty'],
    'plaster':    ['plaster', 'plastry', 'plastrów', 'plastra'],
    'pęczek':     ['pęczek', 'pęczki', 'pęczków', 'pęczka'],
    'puszka':     ['puszka', 'puszki', 'puszek', 'puszki'],
    'słoik':      ['słoik', 'słoiki', 'słoików', 'słoika'],
    'szklanka':   ['szklanka', 'szklanki', 'szklanek', 'szklanki'],
    'opakowanie': ['opakowanie', 'opakowania', 'opakowań', 'opakowania'],
    'kostka':     ['kostka', 'kostki', 'kostek', 'kostki'],
    'listek':     ['listek', 'listki', 'listków', 'listka'],
    'gałązka':    ['gałązka', 'gałązki', 'gałązek', 'gałązki'],
    'kropla':     ['kropla', 'krople', 'kropli', 'kropli'],
    'filiżanka':  ['filiżanka', 'filiżanki', 'filiżanek', 'filiżanki']
  };
  var EN_FORMS = {
    'łyżka':      ['tbsp', 'tbsp'],
    'łyżeczka':   ['tsp', 'tsp'],
    'ząbek':      ['clove', 'cloves'],
    'garść':      ['handful', 'handfuls'],
    'kromka':     ['slice', 'slices'],
    'szczypta':   ['pinch', 'pinches'],
    'plaster':    ['slice', 'slices'],
    'plasterek':  ['slice', 'slices'],
    'pęczek':     ['bunch', 'bunches'],
    'puszka':     ['can', 'cans'],
    'słoik':      ['jar', 'jars'],
    'szklanka':   ['cup', 'cups'],
    'opakowanie': ['pack', 'packs'],
    'kostka':     ['cube', 'cubes'],
    'listek':     ['leaf', 'leaves'],
    'gałązka':    ['sprig', 'sprigs'],
    'kropla':     ['drop', 'drops'],
    'filiżanka':  ['cup', 'cups']
  };
  var EN_LEMMA = { 'plasterki': 'plasterek', 'plasterków': 'plasterek', 'plasterka': 'plasterek' };
  Object.keys(FORMS).forEach(function (lemma) {
    FORMS[lemma].forEach(function (form) {
      if (!EN_LEMMA[form]) EN_LEMMA[form] = lemma;
    });
  });

  function round2(n) {
    return Math.round(n * 100) / 100;
  }

  function category(n) {
    if (!Number.isInteger(n)) return 3;
    var i = Math.abs(n);
    if (i === 1) return 0;
    var m10 = i % 10;
    var m100 = i % 100;
    if (m10 >= 2 && m10 <= 4 && !(m100 >= 12 && m100 <= 14)) return 1;
    return 2;
  }

  function toNumber(value) {
    if (typeof value === 'number') return value;
    return parseFloat(String(value).replace(',', '.'));
  }

  function formatAmount(value) {
    var n = toNumber(value);
    if (!isFinite(n)) return '';
    return EN_MODE ? String(round2(n)) : String(round2(n)).replace('.', ',');
  }

  function unit(value, key) {
    if (!key) return '';
    var raw = String(key).trim();
    var norm = raw.toLowerCase();
    if (EN_MODE) return enUnit(value, norm, raw);
    if (INVARIANT.indexOf(norm) !== -1) return norm;
    var forms = FORMS[norm];
    if (!forms) return raw;
    var n = toNumber(value);
    if (!isFinite(n)) return forms[0];
    return forms[category(round2(n))];
  }

  function enUnit(value, norm, raw) {
    if (norm === 'szt') return '';
    if (INVARIANT.indexOf(norm) !== -1) return norm;
    var forms = EN_FORMS[EN_LEMMA[norm] || norm];
    if (!forms) return raw;
    var n = round2(toNumber(value));
    return isFinite(n) && n > 1 ? forms[1] : forms[0];
  }

  window.UrbUnits = {
    formatAmount: formatAmount,
    unit: unit
  };
})();